import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { RequestDayInfoService } from 'src/app/services/StoreService/RequestDayInfoService/request-day-info-service.service';
import { debounceTime, map } from 'rxjs/operators';
import { fromEvent } from 'rxjs';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit {

  constructor(
    private requestDayInfoService: RequestDayInfoService
  ) { }

  @Input() totalPages: number;
  @Input() totalElements: number;

  actualPage: number = this.requestDayInfoService.getActualPage();

  @Output() change = new EventEmitter();

  ngOnInit(): void {
    const search = document.getElementById("search");

    const keyup = fromEvent(search, "keyup");

    keyup.pipe(
      map((e: any) => e), debounceTime(2000)
    ).subscribe(e =>
      this.searchPage(e)
    );
  }

  before() {
    this.actualPage = Number(this.actualPage) - 1;
    this.requestDayInfoService.newActualPage(this.actualPage);
    this.change.emit(this.actualPage);
  }

  next() {
    this.actualPage = Number(this.actualPage) + 1;
    this.requestDayInfoService.newActualPage(this.actualPage);
    this.change.emit(this.actualPage);
  }

  searchPage(event) {
    let page = event.target.value;

    if (page > this.totalPages) {
      this.requestDayInfoService.newActualPage(this.totalPages);
      this.change.emit(this.totalPages - 1);
    } else if(page <= 0){
      this.requestDayInfoService.newActualPage(1);
      this.change.emit(1);
    } else {
      this.requestDayInfoService.newActualPage(page);
      this.change.emit(this.actualPage);
    }
  }

}
